/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tut_Start_L3Inputs */

const en_wc_tut_start_l3 = /** @type {(inputs: Wc_Tut_Start_L3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The interface follows your system language. Chinese, Japanese, Spanish, German and 15+ more are built in.`)
};

/**
* | output |
* | --- |
* | "The interface follows your system language. Chinese, Japanese, Spanish, German and 15+ more are built in." |
*
* @param {Wc_Tut_Start_L3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tut_start_l3 = /** @type {((inputs?: Wc_Tut_Start_L3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tut_Start_L3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tut_start_l3(inputs)
});
export { wc_tut_start_l3 as "wc.tut.start.l3" }